import React, { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'

interface CustomInputProps {
    label: string;
    type: string;
    setFieldValue: (field: string, value: any) => void;
    value: string | number;
    touched: boolean;
    error: string | undefined;
    handleBlur: (e: React.FocusEvent<any>) => void;
}

const CustomInput: React.FC<CustomInputProps> = ({
    label,
    type,
    setFieldValue,
    value,
    touched,
    error,
    handleBlur,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(label?.split(' ')?.join('').toLowerCase(), e.target.value);
    };

    return (
        <div className="w-full my-2">
            <label className="font-semibold text-text_2">{label}</label>
            <br />
            <div className="relative flex items-center rounded-lg w-full mt-2">
                <input
                    type={showPassword ? 'text' : type}
                    className="flex-grow border-2 p-2 rounded-lg w-full focus:border-secondary focus:outline-none"
                    placeholder={`Enter ${label.toLowerCase()}`}
                    onChange={handleChange}
                    value={value}
                    onBlur={handleBlur}
                    name={label?.split(' ')?.join('').toLowerCase()}
                />
                {type === 'password' && (
                    <button
                        type="button"
                        className="outline-none focus:outline-none text-text_2 absolute top-3 right-2 z-10 cursor-pointer"
                        onClick={togglePasswordVisibility}
                    >
                        {showPassword ? (
                            <AiFillEyeInvisible size={20} />
                        ) : (
                            <AiFillEye size={20} />
                        )}
                    </button>
                )}
            </div>
            {(touched && error) ? (
                <span className="text-error text-sm mt-1">{error}</span>
            ) : null}
        </div>
    );
};

export default CustomInput;
